import * as tslib_1 from "tslib";
import getMrsConnectedAccountsOperation from 'owa-service/lib/operation/getMrsConnectedAccountsOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
export function getMrsConnectedAccounts() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var request, response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        Header: getJsonRequestHeader(),
                        RequestWorkloadType: 'SyncAggregation',
                        SyncProtocols: ['Imap', 'Pop', 'Unified'],
                    };
                    return [4 /*yield*/, getMrsConnectedAccountsOperation(request)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}
//# sourceMappingURL=getMrsConnectedAccounts.js.map